import BaseFactory from 'BaseFactory.js'
import sequenceService from 'SequenceService.js';
import factoryService   from 'FactoryService.js';
import themeService     from 'ThemeService.js';
import listService from 'ListService';

class BaseBehaviorFactory extends BaseFactory {

    constructor() {
        super();
    }


    createChildAttributes(  factoryKey, pos ) {

        const factoryParams = factoryService.behaviorsFactories[factoryKey];
        const nextTabIndex=sequenceService.nextTabIndex();
        const nextZIndex=sequenceService.nextZIndex();

        const defaultFont = listService.accountSettings.DefaultFontSelected || "verdana";
        // For formal definition of keys, see constants.
        // TODO Verify / use PF item names.
        return  {
            attrId: new Date().getTime(),
            backgroundColor:  'transparent',
            boldSelection: '',
            borderColor: 'green',//"#CCCCCC",
            dpi: 72,
            factoryKey: factoryKey,
            fontFamily: '',
            fontSize: '',
            gridWidth: 20,
            gridHeight: 20,
            height:  30,
            italicSelection: '',
            left: pos ? pos.left : 0,
            name: factoryParams.name,
            pageColor: '#FFFFFF', // or #FFFF99
            shadow: 'true',
            silent: false,
            styleColorText: '#000000',
            tabEnabled : false,
            tabIndex: nextTabIndex,
            textFont: themeService[ '~textFont' ],              //'verdana, 10, normal, normal',
            textSize : '',
            textStyle: 'normal',
            textWeight: 'normal',
            titleFont: defaultFont + ', 10',
            toolTip : '',
            top: pos ? pos.top  : 0,
            width: 100,
            zOrder: nextZIndex,
            originalZOrder:nextZIndex,
            isMandatory: false
        };

    }

    // Children overrdide this method
    createView( factoryKey, pos ) {
        throw 'BaseBehaviorFactory.createView( factoryKey, pos ) is an abstract method.';
    }

}

export default BaseBehaviorFactory;
